import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram, Search, Github } from 'lucide-react';

const Navbar: React.FC = () => {
    const [isScrolled, setIsScrolled] = React.useState(false);

    React.useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className="w-full relative z-50">
            {/* Top Bar */}
            <div className="bg-[#0a1b45] text-white text-xs py-2 hidden md:block border-b border-gray-700">
                <div className="container mx-auto px-4 flex justify-between items-center">
                    <div className="flex items-center space-x-6">
                        <div className="flex items-center space-x-2">
                            <Mail size={14} className="text-blue-400" />
                            <span>asaphowou@gmail.com</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <Phone size={14} className="text-blue-400" />
                            <span>+225 07 10 14 59 75</span>
                        </div>
                        <div className="flex items-center space-x-2">
                            <MapPin size={14} className="text-blue-400" />
                            <span>Abidjan, Côte d'Ivoire</span>
                        </div>
                    </div>
                    <div className="flex items-center space-x-4">
                        <div className="flex space-x-3">
                            <a href="https://www.facebook.com/share/1buFm8P4Rs/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors"><Facebook size={14} /></a>
                            <a href="https://github.com/asaph65" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors"><Github size={14} /></a>
                            <a href="https://www.linkedin.com/in/asaph-onesime-ndja-aba34b296?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors"><Linkedin size={14} /></a>
                            <a href="https://www.instagram.com/fastcv2?igsh=MTR0eDdkNDFrYWYzOQ==" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors"><Instagram size={14} /></a>
                        </div>
                        <div className="flex items-center space-x-1 border-l border-gray-600 pl-4">
                            <span>Français</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <div className={`w-full transition-all duration-300 z-50 ${isScrolled ? 'fixed top-0 bg-white shadow-md' : 'absolute top-0 md:top-10 bg-transparent'}`}>
                <div className="container mx-auto px-4 py-4 flex justify-between items-center">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2">
                        <img src="/flashcv.png" alt="FlashCv Logo" className="h-10 w-auto object-contain" />
                        <span className={`text-2xl font-bold transition-colors ${isScrolled ? 'text-[#0a1b45]' : 'text-white'}`}>FlashCv</span>
                    </Link>

                    {/* Navigation Links */}
                    <nav className={`hidden lg:flex items-center space-x-8 font-medium transition-colors ${isScrolled ? 'text-gray-700' : 'text-white/90'}`}>
                        <Link to="/" className={`${isScrolled ? 'text-blue-600' : 'text-white font-bold hover:text-blue-200'}`}>Accueil</Link>
                        <a href="#about" className={`transition-colors ${isScrolled ? 'hover:text-blue-600' : 'hover:text-blue-200'}`}>À propos</a>
                        <a href="#services" className={`transition-colors ${isScrolled ? 'hover:text-blue-600' : 'hover:text-blue-200'}`}>Services</a>
                        <a href="#modeles" className={`transition-colors ${isScrolled ? 'hover:text-blue-600' : 'hover:text-blue-200'}`}>Modèles</a>
                        <a href="#blog" className={`transition-colors ${isScrolled ? 'hover:text-blue-600' : 'hover:text-blue-200'}`}>Blog</a>
                        <a href="#contact" className={`transition-colors ${isScrolled ? 'hover:text-blue-600' : 'hover:text-blue-200'}`}>Contact</a>
                        <button className={`${isScrolled ? 'text-gray-500 hover:text-blue-600' : 'text-white hover:text-blue-200'}`}><Search size={20} /></button>
                    </nav>

                    {/* CTA Button */}
                    <div className="hidden lg:block">
                        <Link to="/login" className="bg-blue-600 text-white px-6 py-2.5 rounded-full font-semibold hover:bg-blue-700 transition-colors shadow-lg shadow-blue-500/30">
                            Se connecter
                        </Link>
                    </div>

                    {/* Mobile Menu Toggle (Simplified) */}
                    <button className={`lg:hidden transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                        </svg>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
